import Vuex from 'vuex';
import Vue from "vue";
import {login} from '@/utils/requestFn';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {},
  state: {
    globalLoading: {
      loading: false,
    },
    loginForm: {
      account: '',
      password: '',
    },
    guestForm: {
      name: '',
      company: '',
      job: '',
      code: '+86',
      phone: '',
      comment: '',
    },
    guestRef: null,
    loginRef: null,
    loginError: false,
  },
  getters: {},
  actions: {
    async login(context) {
      const loginForm = context.state.loginForm;
      await login(loginForm);
    },
    async validateGuestForm(context) {
      const guestRef = context.state.guestRef;
      if (guestRef) {
        return await guestRef.validate();
      }
      return false;
    },
  },
  mutations: {
    setLoginForm(state, loginForm) {
      state.loginForm = loginForm;
    },
    setGuestForm(state, guestForm) {
      state.guestForm = guestForm;
    },
    setGuestRef(state, guestRef) {
      state.guestRef = guestRef;
    },
    setLoginRef(state, loginRef) {
      state.loginRef = loginRef;
    },
    setLoginError(state, isError) {
      state.loginError = isError;
    }
  },
})
